<script setup lang="ts">
import { AuthLoginForm } from '@/modules/auth/components';
definePageMeta({
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/',
  },
  layout: 'guest',
});

useHead({
  title: 'Login',
});
</script>
<template>
  <v-container class="d-flex align-center px-4 justify-center">
    <AuthLoginForm data-testid="login-form" />
  </v-container>
</template>
<style lang="scss" scoped>
.v-container {
  height: 100%;
}
.v-form {
  width: 100%;
  max-width: 500px;
  display: inline-block;
  position: relative;
  margin: auto;
}
</style>
